import { Divider, Input } from 'antd';
import moment from 'moment';
import { useEffect } from 'react';
// import moment from 'moment';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '../methods/redux/hooks';
import { getCurrencies } from '../methods/redux/reducers/currency';
import { PageHeader } from '../theme/theme';

const SettingsItemStyle = styled(Link)`
	padding: 20px;
	border-bottom: 1px solid #ddd;
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	transition: background-color 400ms ease;

	& .desc {
		width: 75%;
		font-size: 15px;
		color: #969696;
		margin-top: 10px;
	}

	& .icon {
		width: 50px;
		display: flex;
		flex-direction: column;
		height: 100%;
		justify-content: flex-start;
		margin-right: 10px;
	}

	&:hover {
		background-color: #fafafa;
	}
`;

const Maintenance = () => {
	const dispatch = useAppDispatch();
	const { currencies } = useAppSelector((store: any) => store.currencies);

	useEffect(() => {
		if (currencies.length < 1) {
			dispatch(getCurrencies({}));
		}
	}, []);
	const items = [
		{
			title: 'Requests Report',
			desc: 'This gives information about the total requests, successful requests bad requests and error requests',
			link: `/reports/maintenance`,
			icon: 'request_quote',
		},
		{
			title: 'Email Bounce Maintenance',
			desc: 'This gives information about the total email bounce',
			link: `/maintenance/email-bounce`,
			icon: 'mail_lock',
		},
		{
			title: 'Account deletion Processing List',
			desc: 'This gives information about the all the users that have requested for their account to be deleted',
			link: `/maintenance/account-deletion`,
			icon: 'mail_lock',
		},
		{
			title: 'Fixed Savings termination requests',
			desc: 'This gives information about the fixed savings that the users requested to be terminated',
			link: `/core-modules/fixed-savings/termination`,
			icon: 'money_off',
		},
		{
			title: 'All 2fa Requests Maintenance',
			desc: 'Here the admin can get information about all the 2fa requests on the system',
			link: `/maintenance/2fa-reset-request?filter=pending&perPage=10&pageId=1`,
			icon: 'mail_lock',
		},
		{
			title: 'Ghost Users',
			desc: 'Here the admin can view all the ghost users',
			link: `/users/ghost-users?startDate=2021-10-01&endDate=${moment().format(
				'YYYY-MM-DD'
			)}&perPage=10&pageId=1&sort=desc`,
			icon: 'person_off',
		},
		{
			title: 'Unverified Users Maintenance',
			desc: 'Here, admin can manage users with fake/temporal emails',
			link: `/users/unverified-users?startDate=2021-10-01&endDate=${moment().format(
				'YYYY-MM-DD'
			)}&perPage=10&pageId=1&sort=desc`,
			icon: 'verified_user',
		},
		{
			title: 'Manual Switch Funding',
			desc: `Here, admin can manually remit funds to a user&apos;s account if any error occurs in the process of funding`,
			link: `/maintenance/manual-switch-funding?startDate=2021-10-01&endDate=${moment().format(
				'YYYY-MM-DD'
			)}&perPage=10&pageId=1&sort=desc`,
			icon: 'verified_user',
		},
		{
			title: 'Service Status maintenance',
			desc: 'Here, admin will see all the services that is being managed my robot and it monitored from this page',
			link: `/maintenance/service-status`,
			icon: 'engineering',
		},
	];

	return (
		<section>
			<PageHeader>Maintenace</PageHeader>

			<Input.Search placeholder="Search" />

			<Divider />

			<p>Frequently visited</p>

			<Divider />

			{items
				.sort((prev, next) => prev.title.localeCompare(next.title))
				.map((item) => (
					<SettingsItemStyle key={item.title} to={item.link}>
						<div style={{ display: 'flex' }}>
							<div className="icon">
								<span className="material-icons">{item.icon}</span>
							</div>
							<div>
								<p>
									<strong>{item.title}</strong>
								</p>
								<p className="desc">{item.desc}</p>
							</div>
						</div>
						<div className="arrow">
							<span className="material-icons">keyboard_arrow_right</span>
						</div>
					</SettingsItemStyle>
				))}
		</section>
	);
};

export default Maintenance;
